<template>
  <div>
    <div class="table-box" style="paddingTop:10px">
      <el-button
        @click="back"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <!--查询-->
      <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />

      <!--列表-->
      <div class>
        <el-table
          style="width: 100%"
          v-loading="loading"
          row-key="id"
          ref="recordList"
          :data="tableData"
          :stripe="false"
          :highlight-current-row="false"
          header-row-class-name="noBorder"
        >
          <!-- <el-table-column
            type="selection"
            width="55"
            row-key="id"
            :reserve-selection="true"
          ></el-table-column> -->
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="序号"
            type="index"
            width="80px"
          />
          <el-table-column type="expand" align="center">
            <template slot-scope="{ row }">
              <ul class="fileUl">
                <li v-for="item in row.fileDataList" :key="item.fileUrl">
                  <div>
                    <label>文件名称</label>
                    <span
                      @click="jump(item.fileUrl)"
                      style="color:#367BF2;cursor:pointer;"
                    >
                      {{ item.fileName }}
                    </span>
                  </div>
                  <!-- <div>
                    <label>上传时间</label>
                    <span>{{ item.createDt | transMonth }}</span>
                  </div> -->
                </li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="fullName"
            label="项目参与人"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="projectStructureType === 2"
            align="center"
            prop="userEnterpriseName"
            label="个体"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="taskDt"
            label="任务月度"
            width="120"
          >
            <template slot-scope="{ row }">{{ row.taskDt | transMonth2 }}</template>
          </el-table-column> -->
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="folderName"
            label="文件夹名称"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="taskCode"
            label="任务编码"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="fileCount"
            align="center"
            label="附件数"
          ></el-table-column>
          <el-table-column
            label="服务商审核人"
            align="center"
            v-if="showReviewer"
          >
            <template slot-scope="scope">
              {{ dealReviewer(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="状态"
          >
            <template slot-scope="scope">
              {{ scope.row.auditGongyeStatus | transAuditStatus }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="check(scope.row)">查看</el-button>
              <el-button :disabled="scope.row.auditGongyeStatus !== 1" type="text" size="small" @click="approve(2,scope.row)">通过</el-button>
              <rejectComponent :disabled="scope.row.auditGongyeStatus !== 1" @withdraw="(item)=>approve(3,scope.row,0,item)"/>
            </template>
          </el-table-column> -->
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { zsBingli, search, protocolService, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import rejectComponent from '@/components/Task/components/reject.vue';
import searchbar from '@/components/Survey/searchbar';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';
import { setStorage, getStorage } from '@/tools/storage';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: protocolService.queryAgreementServiceDetailList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        statementId: this.$route.query.statementId,
        ...getStorage('recordsearchQuery')
      },
      searchAjax: search.yshEnterpriseList,
      peopleNumShow: false, //活动参与人数是否展示
      prop: {
        label: 'enterpriseName',
        code: 'enterpriseId'
      }
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },

  computed: {},
  methods: {
    back() {
      localStorage.removeItem('recordsearchQuery');
      this.$router.back();
    },
    jump(fileUrl) {
      window.open(
        protocolService.downloadAgreementServiceFile +
          '?' +
          'fileUrl=' +
          fileUrl
      );
    },
    check(row) {
      setStorage('recordsearchQuery', this.searchQuery);
      this.$router.push({
        name: 'caseRecordAddEdit',
        query: {
          id: row.id,
          auditGongyeStatus: row.auditGongyeStatus,
          statementId: this.$route.query.statementId
        }
      });
    },
    exportEvent() {
      let queryString = this.$querystring.stringify(this.searchQuery);
      window.open(
        protocolService.exportAgreementServiceDetailList + '?' + queryString
      );
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.enterpriseId;
    },
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },

    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        zsBingli
          .authBingli({
            id: row.id,
            authStatus: status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },

  created() {
    //只在协定服务并且是活动形式的任务展示
    const {
      fileUpSource,
      fileUpMode,
      projectType
    } = this.$store.state.homeProject;
    const isEntry = [+fileUpSource, +fileUpMode].join(',');
    this.peopleNumShow = ['1,1', '3,1'].includes(isEntry) && projectType === 19;
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.fileUl {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    border-radius: 4px;
    background: #f7f9fc;
    padding: 20px;
    // margin-right: 64px;
    justify-content: space-between;
    margin: 15px 22px;
    display: flex;
    width: 250px;
    box-sizing: border-box;
    position: relative;
    .closeIcon {
      position: absolute;
      top: 0px;
      right: 0px;
      opacity: 0.5;
      font-size: 16px;
      cursor: pointer;
    }
    div {
      display: flex;
      flex-direction: column;
      label {
        color: #333;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 24px;
        line-height: 1;
      }
      span {
        font-size: 14px;
        color: #666;
        line-height: 1;
      }
    }
  }
}
</style>
<style lang="scss">
.noBorder th {
  border: none !important;
}
</style>
